/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1623
 */

var r = require(/* 425 */"../1780/425")
var o = require(/* 1624 */"./1624")
var i = require(/* 246 */"../1782/246/index")("toPrimitive")
var /* [auto-meaningful-name] */Date$prototype = Date.prototype
if (!(i in Date$prototype)) {
  r(Date$prototype, i, o)
}
